import { r as registerInstance, h, F as Fragment, g as getElement } from './index-5faac9d7.js';
import { o as omit_1 } from './omit-926f9b3a.js';
import { t as CircularProductTypes, $ as ECarouselRelation, aF as LINK_TYPES, a3 as PRODUCT } from './currency-7be6806c.js';
import { s as store, b as pesCatalogPageTypes } from './pes-router-store-0c1092be.js';
import { an as store$1, ar as setLinearProductData } from './index-e29b327a.js';
import { l as lodash } from './lodash-bd96d09c.js';
import './product-card-c5e7a62c.js';
import './store-22db8dad.js';
import { P as PesRoute } from './pes-route-5a1043d8.js';
import { g as getIsCustomAddToCartEnabled, d as getCustomAddToCartSettings, a as getIsProductsInCustomCart, b as getIsCustomAddToFavoritesEnabled, e as getCustomAddToFavoritesSettings, n as navigateWithRouter } from './utils-e0387569.js';
import { a as getFilteredBreadcrumbs } from './utils-5c7c3926.js';
import './toString-10b0f228.js';
import './_nodeUtil-f95b2b52.js';
import './_commonjsHelpers-11ca3be1.js';
import './isEmpty-51908328.js';
import './isSymbol-bae590b5.js';
import './_Stack-68736bd1.js';
import './keysIn-6ff99c07.js';
import './_arrayLikeKeys-728b0edd.js';
import './_isIndex-3036d479.js';
import './_copyObject-8b49fce6.js';
import './_getAllKeys-407edbf9.js';
import './_getAllKeysIn-c79cfca8.js';
import './_flatRest-cb1a737b.js';
import './_baseFlatten-65704796.js';
import './index-54dd34b7.js';
import './analytics-205f1857.js';
import './checkoutEventEmitter.service-41cc6ce1.js';
import './_basePickBy-e4f30088.js';
import './hasIn-53d8ae96.js';
import './index-5d9a618b.js';
import './pes-product-link-74e48119.js';
import './utils-5735b62e.js';
import './helpers-c4d5ad02.js';
import './tslib.es6-613ce1cd.js';
import './__node-resolve_empty-7dfe5913.js';
import './helpers-e12aa36b.js';
import './toNumber-6e3a0b09.js';
import './index-e233ecdd.js';
import './cta-list-298471fe.js';
import './_baseFor-a28737de.js';
import './constants-7d3b1dc0.js';
import './number-57a50dcb.js';
import './analytics-b6a65ffa.js';
import './utils-6c8f178b.js';

const pesAppSprykerPdpCss = ":host{display:block}@media screen and (max-width: 719px){.pes-app-pdp__section:not(.pes-app-pdp__section--breadcrumbs)+.pes-app-pdp__section{margin-top:20px}}@media screen and (min-width: 980px){.pes-app-pdp__section:not(.pes-app-pdp__section--breadcrumbs)+.pes-app-pdp__section{margin-top:8px}}@media screen and (min-width: 980px){.pes-app-pdp__section--breadcrumbs{background-color:#ffffff;padding-bottom:8px}}";

const PesAppPdp = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.productId = undefined;
    this.localeCode = undefined;
    this.productCtas = undefined;
    this.allData = undefined;
    this.epdsData = undefined;
    this.status = undefined;
    this.enableCommerceConnector = undefined;
    this.showBuyOnline = undefined;
    this.showBreadcrumbs = undefined;
    this.showFaq = undefined;
    this.showCompare = undefined;
    this.showCustomPrice = undefined;
    this.customPrice = undefined;
    this.ddc = undefined;
    this.recentlyViewedProducts = undefined;
    this.isPBS = false;
    this.countryCode = undefined;
    this.languageCode = undefined;
    this.host = undefined;
    this.storageName = '';
  }
  componentWillRender() {
    store.set('enableAppRouting', true);
    store.set('productCTAs', this.productCtas);
    store.set('showCustomPrice', this.showCustomPrice);
    store.set('customPrice', this.customPrice);
  }
  componentWillLoad() {
    this.storageName = `${this.host}${this.countryCode}/${this.languageCode}/`;
  }
  watchProductCtas(newValue, oldValue) {
    if (lodash.isEqual(oldValue, newValue)) {
      return;
    }
    store.set('productCTAs', newValue);
    const { data } = store$1.getState().product;
    if (!data) {
      return;
    }
    const updatedBase = Object.assign(Object.assign({}, data[CircularProductTypes.LINEAR].base), { ctaArea: this.productMainAreaCTAData, links: this.customLinks, offlineStores: this.customOfflineStores });
    const updatedProductData = Object.assign(Object.assign({}, data[CircularProductTypes.LINEAR]), { base: updatedBase });
    store$1.dispatch(setLinearProductData(updatedProductData));
  }
  get customBreadcrumbs() {
    var _a;
    if (!this.showBreadcrumbs) {
      return null;
    }
    return {
      breadcrumbs: getFilteredBreadcrumbs((_a = this.allData) === null || _a === void 0 ? void 0 : _a.breadcrumbs),
    };
  }
  get productMainAreaCTAData() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const mainAreaCTAData = Object.assign(Object.assign({}, (_a = this.allData) === null || _a === void 0 ? void 0 : _a.base.ctaArea), { buttons: {} });
    const defaultButtons = ((_b = this.allData) === null || _b === void 0 ? void 0 : _b.base.ctaArea.buttons) || {};
    if (getIsCustomAddToCartEnabled()) {
      let defaultLabel = (_c = getCustomAddToCartSettings().labels) === null || _c === void 0 ? void 0 : _c.addLabel;
      if (getIsProductsInCustomCart([this.productId])) {
        defaultLabel = (_d = getCustomAddToCartSettings().labels) === null || _d === void 0 ? void 0 : _d.removeLabel;
      }
      mainAreaCTAData.buttons["ADD_TO_CART_BUTTON"] = {
        labels: {
          defaultLabel: defaultLabel || ((_e = this.allData) === null || _e === void 0 ? void 0 : _e.addToCartLabel),
        },
      };
    }
    if (this.showBuyOnline
      && ((_g = (_f = defaultButtons["BUY_ONLINE_BUTTON_REGULAR"]) === null || _f === void 0 ? void 0 : _f.labels) === null || _g === void 0 ? void 0 : _g.defaultLabel)) {
      mainAreaCTAData.buttons["BUY_ONLINE_BUTTON_REGULAR"] = {
        labels: {
          defaultLabel: (_j = (_h = defaultButtons["BUY_ONLINE_BUTTON_REGULAR"]) === null || _h === void 0 ? void 0 : _h.labels) === null || _j === void 0 ? void 0 : _j.defaultLabel,
        },
      };
    }
    if ("DOWNLOAD_BUTTON" in defaultButtons) {
      mainAreaCTAData.buttons["DOWNLOAD_BUTTON"] = defaultButtons["DOWNLOAD_BUTTON"];
    }
    if ("NOTIFY_ME_BUTTON" in defaultButtons) {
      mainAreaCTAData.buttons["NOTIFY_ME_BUTTON"] = defaultButtons["NOTIFY_ME_BUTTON"];
    }
    return mainAreaCTAData;
  }
  get customLinks() {
    var _a, _b, _c, _d, _e, _f;
    const links = {};
    if (getIsCustomAddToFavoritesEnabled()) {
      links[LINK_TYPES.ADD_TO_MY_PRODUCTS] = {
        labels: {
          defaultLabel: ((_a = getCustomAddToFavoritesSettings().labels) === null || _a === void 0 ? void 0 : _a.addLabel) || ((_b = this.allData) === null || _b === void 0 ? void 0 : _b.addToFavoritesLabel),
          removeLabel: ((_c = getCustomAddToFavoritesSettings().labels) === null || _c === void 0 ? void 0 : _c.removeLabel)
            || ((_d = getCustomAddToFavoritesSettings().labels) === null || _d === void 0 ? void 0 : _d.addLabel)
            || ((_e = this.allData) === null || _e === void 0 ? void 0 : _e.removeFromFavoritesLabel),
        },
      };
    }
    if (this.showCompare) {
      links[LINK_TYPES.COMPARE] = {
        labels: { defaultLabel: (_f = this.allData) === null || _f === void 0 ? void 0 : _f.base.links.COMPARE.labels.defaultLabel },
      };
    }
    return links;
  }
  get customOfflineStores() {
    var _a;
    return omit_1((_a = this.allData) === null || _a === void 0 ? void 0 : _a.base.offlineStores, 'findResellerLink');
  }
  render() {
    var _a;
    if (this.status.isLoading.all) {
      return h("pdp-skeleton", null);
    }
    if (!this.allData)
      return;
    if (typeof this.status.error.all === 'object') {
      const route = new PesRoute({ page: pesCatalogPageTypes.ALL_PRODUCTS });
      navigateWithRouter(route, this.el);
    }
    const { useNewUiForLifecycle } = this.allData.config;
    const pageData = {
      hostWithLocale: this.storageName,
      pageType: PRODUCT,
      pageId: this.productId,
    };
    return (h(Fragment, null, this.showBreadcrumbs && (h("pes-breadcrumbs", Object.assign({}, this.customBreadcrumbs, { hideOnMobile: true, class: "pes-app-pdp__section pes-app-pdp__section--breadcrumbs", hostWithLocale: this.storageName }))), h("pes-product-main", Object.assign({}, (_a = this.allData) === null || _a === void 0 ? void 0 : _a.base, { productId: this.productId, productCR: this.productId, localeCode: this.localeCode, ctaArea: this.productMainAreaCTAData, links: this.customLinks, offlineStores: this.customOfflineStores, enableCommerceConnector: this.enableCommerceConnector, showBuyOnline: this.showBuyOnline, showCompare: this.showCompare, countryCode: this.countryCode, class: "pes-app-pdp__section", isPBS: this.isPBS, host: this.host, languageCode: this.languageCode }), h("slot", { name: "discounted-price", slot: "discounted-price" })), h("pes-asset-bar-and-related-products", Object.assign({}, this.allData.assetBarRelatedProducts, { localeCode: this.localeCode, class: "pes-app-pdp__section" })), h("pes-products-carousel", Object.assign({ relationType: ECarouselRelation.compatibleSoftware }, this.allData.compatibleSoftware, pageData, { class: "pes-app-pdp__section" })), h("pes-lifecycle-services-wrapper", Object.assign({}, this.allData.crossSellLife, { useNewUiForLifecycle: !!useNewUiForLifecycle, countryCode: this.countryCode, languageCode: this.languageCode, class: "pes-app-pdp__section" })), h("pes-description-and-specifications", Object.assign({}, this.allData.specifications, { class: "pes-app-pdp__section" })), h("pes-environmental-data", Object.assign({}, this.allData.environmentalData, { class: "pes-app-pdp__section" })), h("pes-epds", { epds: this.epdsData, class: "pes-app-pdp__section" }), this.ddc && (h("pes-product-documents-and-software", Object.assign({}, this.ddc, { class: "pes-app-pdp__section" }))), h("pes-products-carousel", Object.assign({ relationType: ECarouselRelation.upsell }, this.allData.upsell, pageData, { class: "pes-app-pdp__section" })), h("pes-products-carousel", Object.assign({ relationType: ECarouselRelation.crosssell }, this.allData.crosssell, pageData, { class: "pes-app-pdp__section" })), this.showFaq && h("pes-faq", Object.assign({}, this.allData.faq, { class: "pes-app-pdp__section" })), h("pes-products-carousel", Object.assign({}, this.recentlyViewedProducts, pageData, { class: "pes-app-pdp__section" }))));
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "productCtas": ["watchProductCtas"]
  }; }
};
PesAppPdp.style = pesAppSprykerPdpCss;

export { PesAppPdp as pes_app_spryker_pdp };
